import {
  ISecurityQuestion,
  ISecurityQuestionConf,
  ISecurityQuestionPost,
} from "../SecurityQuestionsManagement/module/constants";

export const actionTypes = {
  VIEW_PROFILE_MGMT: "VIEW_PROFILE_MGMT",
  VIEW_SECURITY_QUESTIONS_MGMT: "VIEW_SECURITY_QUESTIONS_MGMT",
  DISPATCH_ANSWER_VALUE: "DISPATCH_ANSWER_VALUE",
  DISPATCH_QUESTION_VALUE: "DISPATCH_QUESTION_VALUE",
  DISPATCH_SECURITY_QUESTION: "DISPATCH_SECURITY_QUESTION",
  DISPATCH_OLD_ID: "DISPATCH_OLD_ID",
  DISPATCH_NEW_ID: "DISPATCH_NEW_ID",
  GET_SECURITY_QUESTION: "GET_SECURITY_QUESTION",
  GET_SECURITY_QUESTION_SUCCESS: "GET_SECURITY_QUESTION_SUCCESS",
  GET_SECURITY_QUESTION_FAILURE: "GET_SECURITY_QUESTION_FAILURE",
  GET_CONFIG: "GET_CONFIG",
  GET_CONFIG_SUCCESS: "GET_CONFIG_SUCCESS",
  GET_CONFIG_FAILURE: "GET_CONFIG_FAILURE",
  POST_SECURITY_QUESTIONS: "POST_SECURITY_QUESTIONS",
  POST_SECURITY_QUESTIONS_SUCCESS: "POST_SECURITY_QUESTIONS_SUCCESS",
  POST_SECURITY_QUESTIONS_FAILURE: "POST_SECURITY_QUESTIONS_FAILURE",
  VALIDATE_MOBILE_NUMBER: "VALIDATE_MOBILE_NUMBER",
  VALIDATE_MOBILE_NUMBER_SUCCESS: "VALIDATE_MOBILE_NUMBER_SUCCESS",
  VALIDATE_MOBILE_NUMBER_FAILURE: "VALIDATE_MOBILE_NUMBER_FAILURE",
  ADD_MOBILE_NUMBER: "ADD_MOBILE_NUMBER",
  ADD_MOBILE_NUMBER_SUCESS: "ADD_MOBILE_NUMBER_SUCESS",
  ADD_MOBILE_NUMBER_FAILURE: "ADD_MOBILE_NUMBER_FAILURE",
};

export const viewProfileManagement = () => ({
  type: actionTypes.VIEW_PROFILE_MGMT,
});

export const viewSecurityQuestionsManagement = () => ({
  type: actionTypes.VIEW_SECURITY_QUESTIONS_MGMT,
});

export const dispatchAnswerValue = (answer: string, questionId: number) => ({
  type: actionTypes.DISPATCH_ANSWER_VALUE,
  payload: { answer, questionId },
});

export const dispatchQuestionValue = (
  question: string,
  questionId: number
) => ({
  type: actionTypes.DISPATCH_QUESTION_VALUE,
  payload: { question, questionId },
});

export const dispatchSecurityQuestion = (
  sec: ISecurityQuestion,
  index: number
) => ({
  type: actionTypes.DISPATCH_SECURITY_QUESTION,
  payload: { sec, index },
});

export const dispatchOldId = (oldId: string, index: number) => ({
  type: actionTypes.DISPATCH_OLD_ID,
  payload: { oldId, index },
});

export const dispatchNewId = (newId: string, index: number) => ({
  type: actionTypes.DISPATCH_NEW_ID,
  payload: { newId, index },
});

export const getSecurityQuestion = () => ({
  type: actionTypes.GET_SECURITY_QUESTION,
});
export const getSecurityQuestionSuccess = (payload: ISecurityQuestion[]) => ({
  type: actionTypes.GET_SECURITY_QUESTION_SUCCESS,
  payload,
});
export const getSecurityQuestionFailure = (err: Error) => ({
  type: actionTypes.GET_SECURITY_QUESTION_FAILURE,
  err,
});

export const getConfigs = () => ({
  type: actionTypes.GET_CONFIG,
});
export const getConfigSuccess = (payload: ISecurityQuestionConf) => ({
  type: actionTypes.GET_CONFIG_SUCCESS,
  payload,
});
export const getConfigFailure = (err: Error) => ({
  type: actionTypes.GET_CONFIG_FAILURE,
  err,
});

export const saveSecurityQuestions = (payload: ISecurityQuestionPost) => ({
  type: actionTypes.POST_SECURITY_QUESTIONS,
  payload,
});
export const saveSecurityQuestionsSuccess = (payload: {
  responseId: number;
  responseCode: string;
}) => ({
  type: actionTypes.POST_SECURITY_QUESTIONS_SUCCESS,
  payload,
});
export const saveSecurityQuestionsFailure = (err: Error) => ({
  type: actionTypes.POST_SECURITY_QUESTIONS_FAILURE,
  err,
});

export const validateMobileAction = (payload: any) => ({
  type: actionTypes.VALIDATE_MOBILE_NUMBER,
  payload,
});
export const validateMobileActionSuccess = (payload: {
  responseId: number;
  responseCode: string;
}) => ({
  type: actionTypes.VALIDATE_MOBILE_NUMBER_SUCCESS,
  payload,
});
export const validateMobileActionFailure = (err: Error) => ({
  type: actionTypes.VALIDATE_MOBILE_NUMBER_FAILURE,
  err,
});

export const addMobileNumberAction = (payload: string) => ({
  type: actionTypes.ADD_MOBILE_NUMBER,
  payload,
});
export const addMobileNumberActionSuccess = (payload: string) => ({
  type: actionTypes.ADD_MOBILE_NUMBER_SUCESS,
  payload,
});
export const addMobileNumberActionFailure = (error: any) => ({
  type: actionTypes.ADD_MOBILE_NUMBER_FAILURE,
  error,
});
